import {
    EOD_DAILY_SUMMARY_REQUEST,
    EOD_DAILY_SUMMARY_SUCCESS,
    EOD_DAILY_SUMMARY_FAILURE,
} from "./eodReportsConstants";

export const eodDailySummaryRequest = (data) => {
    return {
        type: EOD_DAILY_SUMMARY_REQUEST,
        payload: data
    };
}

export const eodDailySummarySuccess = (data) => {
    return {
        type: EOD_DAILY_SUMMARY_SUCCESS,
        payload: data
    };
}

export const eodDailySummaryFailure = (error) => {
    return {
        type: EOD_DAILY_SUMMARY_FAILURE,
        payload: error
    };
}
